import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'components/pages';
import { PermissionGuard } from 'components/permissions';
import Exhibitions from 'components/exhibition';

const ExhibitionsRoute: React.FC = () =>
{

  return (
    <PermissionGuard
      permission={Exhibitions.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<Pages.Exhibitions />} />
        <Route path="/:id/*" element={<Pages.Exhibition />} />
        <Route path="/create/*" element={<Pages.Exhibition />} />
      </Routes>
    </PermissionGuard>
  );
};


export default ExhibitionsRoute;
